import { render, staticRenderFns } from "./tab-textings.vue?vue&type=template&id=47db6479"
import script from "./tab-textings.vue?vue&type=script&lang=js"
export * from "./tab-textings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports